import { useMemo } from "react";

import { usePalette } from "metabase/common/hooks/use-palette";
import { useMantineTheme } from "metabase/ui";
import { color } from "metabase/ui/colors";
import { getFontFamilyValue } from "metabase/ui/fonts";
import {
  measureTextHeight,
  measureTextWidth,
} from "metabase/utils/measure-text";
import { getVisualizationTheme } from "metabase/visualizations/shared/utils/theme";
import type { RenderingContext } from "metabase/visualizations/types";

interface RenderingOptions {
  fontFamily: string;
  isDashboard?: boolean;
  isFullscreen?: boolean;
}

export const useBrowserRenderingContext = (
  options: RenderingOptions,
): RenderingContext => {
  const { fontFamily, isDashboard } = options;

  const palette = usePalette();
  const theme = useMantineTheme();

  return useMemo(() => {
    const style = getVisualizationTheme({
      theme: theme.other,
      isDashboard,
    });

    return {
      getColor: (name) => color(name, palette),
      measureText: measureTextWidth,
      measureTextHeight,
      fontFamily: getFontFamilyValue(fontFamily),
      colorScheme: theme.other?.colorScheme ?? "light",
      theme: style,
    };
  }, [fontFamily, palette, theme, isDashboard]);
};
